var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResidencyVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3224 3.22021C25.9262 3.97336 26.2886 4.92805 26.2886 5.96619V5.98661V28.4434V28.4639C26.2886 29.5021 25.9262 30.4567 25.3224 31.2098C26.7777 31.1251 27.9357 29.9169 27.9357 28.4434V5.98661C27.9357 4.51321 26.7777 3.30498 25.3224 3.22021Z",
    fill: "url(#paint0_linear_4402_12173)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4109 13.9209C13.4767 15.041 13.6744 16.089 13.9758 16.8804C14.3125 17.7641 14.6678 18.0385 14.7592 18.0385C14.8505 18.0385 15.2059 17.7641 15.5425 16.8804C15.844 16.089 16.0417 15.041 16.1074 13.9209H13.4109Z",
    fill: "url(#paint1_linear_4402_12173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7592 8.15625C14.6678 8.15625 14.3125 8.43071 13.9758 9.31435C13.6744 10.1058 13.4767 11.1538 13.4109 12.2739H16.1074C16.0417 11.1538 15.8439 10.1058 15.5425 9.31435C15.2059 8.43071 14.8505 8.15625 14.7592 8.15625Z",
    fill: "url(#paint2_linear_4402_12173)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7571 12.2738H19.6313C19.3734 10.7427 18.4089 9.44848 17.0858 8.73926C17.4567 9.71761 17.6887 10.9498 17.7571 12.2738Z",
    fill: "url(#paint3_linear_4402_12173)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7613 12.2738C11.8296 10.9498 12.0617 9.71761 12.4326 8.73926C11.1095 9.44848 10.145 10.7427 9.88702 12.2738H11.7613Z",
    fill: "url(#paint4_linear_4402_12173)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8327 3.21484H4.87695V31.2148H21.8327C23.3815 31.2148 24.6417 29.9715 24.6417 28.4433V5.9864C24.6417 4.45815 23.3815 3.21484 21.8327 3.21484ZM17.2299 27.0972H12.2887V25.4501H17.2299V27.0972ZM18.877 23.8031H10.6417V22.156H18.877V23.8031ZM14.7593 19.6854C11.1266 19.6854 8.17107 16.7299 8.17107 13.0972C8.17107 9.46444 11.1266 6.50896 14.7593 6.50896C18.3921 6.50896 21.3475 9.46444 21.3475 13.0972C21.3475 16.7299 18.3921 19.6854 14.7593 19.6854Z",
    fill: "url(#paint5_linear_4402_12173)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7571 13.9209C17.6887 15.2449 17.4567 16.4771 17.0858 17.4554C18.4089 16.7462 19.3734 15.452 19.6313 13.9209H17.7571Z",
    fill: "url(#paint6_linear_4402_12173)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7613 13.9209H9.88702C10.145 15.452 11.1095 16.7462 12.4326 17.4554C12.0617 16.4771 11.8296 15.2449 11.7613 13.9209Z",
    fill: "url(#paint7_linear_4402_12173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12173",
    x1: 26.629,
    y1: 3.22021,
    x2: 26.629,
    y2: 31.2098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12173",
    x1: 14.7592,
    y1: 13.9209,
    x2: 14.7592,
    y2: 18.0385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12173",
    x1: 14.7592,
    y1: 8.15625,
    x2: 14.7592,
    y2: 12.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12173",
    x1: 18.3585,
    y1: 8.73926,
    x2: 18.3585,
    y2: 12.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_12173",
    x1: 11.1598,
    y1: 8.73926,
    x2: 11.1598,
    y2: 12.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4402_12173",
    x1: 14.7593,
    y1: 3.21484,
    x2: 14.7593,
    y2: 31.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4402_12173",
    x1: 18.3585,
    y1: 13.9209,
    x2: 18.3585,
    y2: 17.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4402_12173",
    x1: 11.1598,
    y1: 13.9209,
    x2: 11.1598,
    y2: 17.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#74ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843325,
    stopColor: "#3A55F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidencyVisa);
export default __webpack_public_path__ + "static/media/Residency & Visa.eb3a8cfb8f654a4bd759de603c1eeffe.svg";
export { ForwardRef as ReactComponent };